export const TypeContactsEmergency = [
  { title: 'SECRETÁRIA', enum: 'SECRETARY' },
  { title: 'FAMILIAR', enum: 'FAMILY' },
  { title: 'OUTROS', enum: 'OTHERS' },
];



